import { Link } from "react-router-dom";
import PageTitle from "@/components/site/PageTitle";

export default function NotFoundPage() {
  return (
    <main
      data-testid="not-found-page"
      className="min-h-[70vh] grid place-items-center grid-bg"
    >
      <PageTitle title="404" />
      <div className="text-center px-6">
        <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--ri-muted)] mb-4">
          404 · File not found
        </div>
        <h1 className="font-display text-7xl md:text-9xl tracking-tighter leading-none">
          Off the <span className="text-[var(--ri-orange)] italic font-display-soft">grid.</span>
        </h1>
        <p className="mt-5 text-[var(--ri-muted)] max-w-md mx-auto">
          We couldn't locate that page. Routes don't always align — let's get you home.
        </p>
        <Link to="/" className="btn-primary mt-8" data-testid="not-found-cta">
          Back to home
        </Link>
      </div>
    </main>
  );
}
